module.exports = __webpack_public_path__ + "js/3.c32a39f8.worker.js"